import { useEffect } from "react";
import { useHistory } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import rootActions, { types as rootAts } from "root/actions";
import { selectTabRoutes } from "../../selectors";


const { [rootAts.SET_TABS_ROUTES]: setTabsRoutesAction } = rootActions.creators;

const useMenuRouteChange = () => {
	const dispatch = useDispatch();
	const history = useHistory();
	const routes = useSelector(selectTabRoutes);

	useEffect(
		() => history.listen((location) => listenCallback(location, routes, dispatch)),
		[dispatch, history, routes]
	);
	return routes;
};

export const listenCallback = (location, routes, dispatch) => {
	const paths = location.pathname.split("/");
	const key = paths[1];

	if (routes[key] !== location.pathname) {
		const newLinks = { ...routes };
		newLinks[key] = location.pathname;
		dispatch(setTabsRoutesAction({ routes: newLinks }));
	}
};

export default useMenuRouteChange;
